export default __webpack_public_path__ + "static/certificate-half-square-e6651403f01168303e6cf09d99bc41be.png";